//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      scroll: 50
    }
  },

  computed: {
    isScrollOut () {
      return this.scroll > 57
    }
  },

  methods: {
    eventHandler () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
    },

    goBack () {
      this.$router.go(-1)
    },

    goToNext () {
      this.$router.go(1)
    }
  },
  created () {
    window.addEventListener('scroll', this.eventHandler)
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.eventHandler)
  }
}  



// WEBPACK FOOTER //
// ./src/components/PageChangerBasic.vue